export const state = {
    location: null,
    deviceType: null,
    devices: []
}

export const getters = {
    location: state => state.location,
    devices: state => state.devices,
    deviceType: state => state.deviceType,
}

export const mutations = {
    setLocation (state, { lat, long, speed }) {
        state.location = { lat, long, speed }
    },
    setDevices (state, devicesArray) {
        state.devices = devicesArray
    },
    setDeviceType (state, type) {
        state.deviceType = type
    },
}

export const actions = {
    async setLocation ({ commit }, { lat, long, speed }) {
        commit('setLocation', { lat, long, speed });
    },
    async setDevices ({ commit }, devices) {
        commit('setDevices', devices);
    },
    async setDeviceType ({ commit }, type) {
        commit('setDeviceType', type);
    },
}
